import { state, props, resolveObject } from 'cerebral/tags'
import { when, set } from 'cerebral/operators'
import { httpUploadFile } from '@cerebral/http/operators'
import getNextFileForUpload from '../actions/getNextFileForUpload'
import copyUploadToFiles from '../actions/copyUploadToFiles'
import getURL from 'utils/getURL'
import createSnackbar from 'modules/App/factories/createSnackbar'
import removeSnackbar from 'modules/App/chains/removeSnackbar'

const trigger = ({ controller, props: { snackbar }, state }) => {
  setTimeout(() => {
    controller.getSignal('media.onUploadNext')({ snackbar })
  }, 0)
}

export default [
  when(state`media.isUploading`),
  {
    true: [],
    false: [
      getNextFileForUpload,
      {
        next: [
          when(props`snackbar`),
          {
            false: [
              createSnackbar(
                { key: 'bms.media.upload.active' },
                'warning',
                true
              )
            ],
            true: []
          },
          set(state`media.isUploading`, true),
          set(state`media.currentUpload.clientId`, props`key`),
          set(state`media.uploading.${props`key`}.pending`, false),
          httpUploadFile(
            getURL('/upload'),
            props`file.file`,
            resolveObject({
              name: 'file',
              headers: props`headers`,
              onProgress: 'media.onUploadProgress'
            })
          ),
          {
            success: [
              when(props`response.result`),
              {
                true: [
                  set(state`media.currentUpload.id`, props`response.result.id`),
                  copyUploadToFiles
                ],
                false: []
              },
              set(state`media.currentUpload`, null),
              set(state`media.isUploading`, false),
              trigger
            ],
            error: [],
            abort: []
          }
        ],
        end: [
          ...removeSnackbar,
          createSnackbar({ key: 'bms.media.upload.done' }, 'success')
        ]
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/modules/Media/chains/onUploadNext.js